import { Box, Stack, Typography } from "@mui/material";

import AppLink from "@/common/components/Link/AppLink";
import GoBackLink from "@/common/components/Link/GoBackLink";
import { ROUTE_PATH } from "@/common/constants/routing";

/** Route not found. */
export default function NotFoundErrorPage() {
  return (
    <Box sx={{ textAlign: "center", p: 2 }}>
      <Typography component='div' variant='h4'>
        Not found
      </Typography>

      <Box>{`The requested resource can't be found.`}.</Box>

      <Stack direction='row' spacing={2} justifyContent='center'>
        <GoBackLink />
        <AppLink to={ROUTE_PATH.ROOT}>Go home</AppLink>
      </Stack>
    </Box>
  );
}
